import { DecimalPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'toMonthAndDay' })
export class ToMonthAndDay implements PipeTransform {
  constructor(private decimalPipe: DecimalPipe) {}
  transform(date: string) {
    return (
      this.decimalPipe.transform(new Date(date).getMonth() + 1, '2.0') +
      '.' +
      this.decimalPipe.transform(new Date(date).getDate(), '2.0') +
      '.'
    );
  }
}
